import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Star, Quote } from "lucide-react";
import { ASSETS } from "@/data/assets";
import api from "@/lib/apiClient";

export default function Testimonials() {
  const { data: items = [], isLoading } = useQuery({ queryKey: ["testimonials"], queryFn: async () => (await api.get("/testimonials")).data });

  return (
    <div data-testid="testimonials-page">
      <section className="relative h-[40vh] min-h-[300px] flex items-end">
        <img src={ASSETS.couple} alt="Happy clients" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/60 to-brand-navy/30" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pb-12 w-full">
          <p className="overline mb-3">Client Love</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">Testimonials</h1>
        </div>
      </section>

      <section className="py-20 max-w-7xl mx-auto px-5 sm:px-8">
        {isLoading && <p className="text-brand-ink/60">Loading…</p>}
        <div className="grid md:grid-cols-2 gap-6">
          {items.map((t) => (
            <div key={t.id} data-testid={`testimonial-${t.id}`} className="relative border border-brand-navy/10 bg-white p-8 rounded-sm">
              <Quote className="text-brand-gold/30 absolute top-6 right-6" size={44} />
              <div className="flex gap-1 text-brand-gold">
                {Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} size={16} fill="currentColor" />)}
              </div>
              <p className="mt-5 text-brand-ink/80 leading-relaxed italic relative">“{t.quote}”</p>
              <div className="mt-6 pt-5 border-t border-brand-navy/10">
                <p className="font-serif text-lg text-brand-navy">{t.name}</p>
                <p className="overline mt-1">{t.event_type}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-brand-navy text-center">
        <div className="max-w-2xl mx-auto px-5">
          <h2 className="font-serif text-3xl sm:text-4xl text-white">Ready to be our next happy story?</h2>
          <Link to="/booking" className="mt-7 inline-flex bg-brand-gold text-brand-navy font-semibold px-8 py-3.5 rounded-sm hover:-translate-y-0.5 transition-transform">
            Plan Your Event
          </Link>
        </div>
      </section>
    </div>
  );
}
